// extracted by mini-css-extract-plugin
export var category = "_ko-9";
export var categoryHeader = "_ko-e";
export var container = "_ko-0";
export var group = "_ko-a";
export var groupItems = "_ko-f";
export var groupSeparator = "_ko-j";
export var loading = "_ko-1";
export var noResults = "_ko-3";
export var placeholder = "_ko-2";
export var resultContent = "_ko-5";
export var resultIcon = "_ko-c";
export var resultItem = "_ko-g";
export var resultMeta = "_ko-8";
export var resultSubtitle = "_ko-7";
export var resultSuffix = "_ko-i";
export var resultTitle = "_ko-6";
export var resultsList = "_ko-4";
export var searchGroup = "_ko-d";
export var selected = "_ko-h";
export var subgroup = "_ko-b";